// core
import React from 'react';

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.STATUS_ERROR = -3;
    this.STATUS_FETCHING = -1;
    this.STATUS_BUSY = this.STATUS_FETCHING;
    this.STATUS_READY = 1;
    this.STATUS_SUCCESS = 2;

    this._status = this.STATUS_READY;
    this._queue = {};
    this._errors = [];

    this.setStatus = this.setStatus.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.getErrors = this.getErrors.bind(this);
    this._makeKey = this._makeKey.bind(this);
    this._abortByKey = this._abortByKey.bind(this);
    this._abortAll = this._abortAll.bind(this);
    this.fetch = this.fetch.bind(this);
    this.abort = this.abort.bind(this);
  }

  componentWillUnmount() {
    console.log('=========================================================');
    console.log('Unmount page...');

    this._abortAll();

    console.log('=========================================================');
  }

  // status
  setStatus(status) {
    const valid = [
      this.STATUS_ERROR,
      this.STATUS_FETCHING,
      this.STATUS_BUSY,
      this.STATUS_READY,
      this.STATUS_SUCCESS
    ];

    if (valid.indexOf(status) === -1) {
      console.error('Invalid status');

      return false;
    }

    this._status = status;
  }
  getStatus() {
    return this._status;
  }
  getErrors() {
    return this._errors;
  }

  // XHR
  _makeKey(method, endpoint) {
    return String(method).toUpperCase() + ' ' + String(endpoint).toLowerCase();
  }

  _abortByKey(key) {
    if (!this._queue[key]) {
      return false;
    }

    const controller = this._queue[key];
    if (!controller) {
      console.error('Controller ' + key + ' does not exist');
    }

    console.log('Abort XHR call: ' + key);

    XHR.abort(controller);
  }
  _abortAll() {
    Object.keys(this._queue).forEach((key) => {
      this._abortByKey(key);
    });
  }

  fetch(method, endpoint, payload, options, callback) {
    const key = this._makeKey(method, endpoint);
    const controller = XHR.fetch(method, endpoint, payload, options, (response, error) => {
      delete this._queue[key];

      if (error) {
        console.dir(error);
        console.log('Error code: ' + error.code);

        // aborting call is not an error
        if (error.code == error.ABORT_ERR) {
          console.log(key + ' aborted.');

          return false;
        }

        this.setStatus(this.STATUS_ERROR);
        this._errors.push({
          code: error.code,
          message: error.message
        });
      }

      if (callback) {
        callback(response, error);
      }
    });

    this._queue[key] = controller;
  }

  abort(method, endpoint) {
    const key = this._makeKey(method, endpoint);

    console.log('Abort ' + key);

    this._abortByKey(key);
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/pages/shared/Page.js